/**
 * Free Gift Promotion — Symmetry 8.0.0
 *
 * Fix inclusi:
 * - Bug 1: Rimozione regalo duplicato prima di aggiungerne uno nuovo
 * - Bug 2+6: Intercetta tutti i button[name="add"] incluso sticky ATC
 * - Bug 4: Spinner su CTA durante il loading
 * - Bug 5: Preload immagini colore all'apertura modale
 */

(function () {
  'use strict';

  const GIFT_PROP = '_free_gift';
  const GIFT_VAL  = 'free-gift-promotion';

  // ── URL normalizer ──────────────────────────────────────────────────────────
  function normalizeUrl(rawUrl) {
    if (!rawUrl) return '';
    if (rawUrl.startsWith('//')) return 'https:' + rawUrl;
    if (rawUrl.startsWith('http')) return rawUrl;
    return 'https://cdn.shopify.com/s/' + rawUrl;
  }

  // ── Spinner CSS ─────────────────────────────────────────────────────────────
  function injectSpinnerCss() {
    if (document.getElementById('fgp-spinner-css')) return;
    const style = document.createElement('style');
    style.id = 'fgp-spinner-css';
    style.textContent = `
      .fgp-modal__cta.is-loading {
        position: relative;
        color: transparent !important;
        pointer-events: none;
      }
      .fgp-modal__cta.is-loading::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 1.6rem;
        height: 1.6rem;
        margin: -0.8rem 0 0 -0.8rem;
        border: 2px solid rgba(255,255,255,0.3);
        border-top-color: #ffffff;
        border-radius: 50%;
        animation: fgp-spin 0.6s linear infinite;
      }
      @keyframes fgp-spin {
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  function init() {
    // ── Move modal to body ────────────────────────────────────────────────────
    const modal = document.getElementById('fgp-modal');
    if (!modal) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    injectSpinnerCss();

    const modalClose  = document.getElementById('fgp-modal-close');
    const modalOver   = document.getElementById('fgp-modal-overlay');
    const modalCta    = document.getElementById('fgp-modal-cta');
    const modalSkip   = document.getElementById('fgp-modal-skip');
    const varInput    = document.getElementById('fgp-variant-id');
    const modalImg    = document.getElementById('fgp-modal-image');
    const unavailable = modal.querySelector('.fgp-modal__unavailable');

    if (!modalCta || !varInput) return;

    // ── Data ──────────────────────────────────────────────────────────────────
    const variants    = JSON.parse(modal.dataset.giftVariants || '[]');
    const colorIndex  = parseInt(modal.dataset.colorIndex || '0', 10);
    const sizeIndex   = colorIndex === 0 ? 1 : 0;
    const optionCount = modal.querySelectorAll('.fgp-modal__option').length;

    // Color → image map from inline script tag
    let colorImageMap = {};
    try {
      const mapScript = document.getElementById('fgp-color-image-map');
      if (mapScript) colorImageMap = JSON.parse(mapScript.textContent);
    } catch(e) {
      console.error('[FGP] colorImageMap parse error:', e);
    }

    // Normalize all URLs upfront
    Object.keys(colorImageMap).forEach(k => {
      colorImageMap[k] = normalizeUrl(colorImageMap[k]);
    });

    // Availability maps
    const colorAvailability = {};
    const sizeAvailabilityForColor = {};
    variants.forEach(v => {
      const color = v.options[colorIndex];
      const size  = v.options[sizeIndex];
      if (!colorAvailability[color]) colorAvailability[color] = false;
      if (!sizeAvailabilityForColor[color]) sizeAvailabilityForColor[color] = {};
      if (v.available) colorAvailability[color] = true;
      sizeAvailabilityForColor[color][size] = v.available;
    });

    let selectedOptions  = new Array(optionCount).fill(null);
    let pendingVariantId = null;
    let pendingQty       = 1;
    let pendingProps     = {};

    // ── Preload all color images ──────────────────────────────────────────────
    // Bug 3: precarica tutte le immagini colore quando la modale si apre
    // così il cambio colore è istantaneo dopo il primo caricamento
    function preloadColorImages() {
      Object.values(colorImageMap).forEach(url => {
        if (!url) return;
        const img = new Image();
        img.src = url;
      });
    }

    // ── Pill states ───────────────────────────────────────────────────────────
    function updatePillStates() {
      const selectedColor = selectedOptions[colorIndex];

      modal.querySelectorAll(`.fgp-modal__pill[data-option-index="${colorIndex}"]`).forEach(btn => {
        const avail = colorAvailability[btn.dataset.optionValue] !== false;
        btn.classList.toggle('is-unavailable', !avail);
        btn.disabled = !avail;
      });

      if (selectedColor !== null) {
        const sizeMap = sizeAvailabilityForColor[selectedColor] || {};
        modal.querySelectorAll(`.fgp-modal__pill[data-option-index="${sizeIndex}"]`).forEach(btn => {
          const avail = sizeMap[btn.dataset.optionValue] !== false;
          btn.classList.toggle('is-unavailable', !avail);
          btn.disabled = !avail;
        });
      } else {
        modal.querySelectorAll(`.fgp-modal__pill[data-option-index="${sizeIndex}"]`).forEach(btn => {
          btn.classList.remove('is-unavailable');
          btn.disabled = false;
        });
      }
    }

    // ── Variant selection ─────────────────────────────────────────────────────
    function selectPill(btn) {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      const val = btn.dataset.optionValue;

      modal.querySelectorAll(`.fgp-modal__pill[data-option-index="${idx}"]`).forEach(b => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      selectedOptions[idx] = val;

      if (idx === colorIndex) {
        // Reset size selection
        selectedOptions[sizeIndex] = null;
        modal.querySelectorAll(`.fgp-modal__pill[data-option-index="${sizeIndex}"]`).forEach(b => {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });

        // Update image
        const url = colorImageMap[val];
        if (url && modalImg) {
          modalImg.classList.add('is-loading');
          const tmp = new Image();
          tmp.onload = () => {
            modalImg.src = tmp.src;
            modalImg.classList.remove('is-loading');
          };
          tmp.onerror = () => {
            modalImg.src = url;
            modalImg.classList.remove('is-loading');
          };
          tmp.src = url;
        }
      }

      updatePillStates();
      updateVariant();
    }

    function updateVariant() {
      if (!selectedOptions.every(v => v !== null)) {
        varInput.value = '';
        modalCta.disabled = true;
        unavailable.hidden = true;
        return;
      }
      const match = variants.find(v => v.options.every((o, i) => o === selectedOptions[i]));
      unavailable.hidden = true;
      if (!match || !match.available) {
        varInput.value = '';
        modalCta.disabled = true;
        if (match && !match.available) unavailable.hidden = false;
        return;
      }
      varInput.value = match.id;
      modalCta.disabled = false;
    }

    modal.querySelectorAll('.fgp-modal__pill').forEach(btn => {
      btn.addEventListener('click', () => { if (!btn.disabled) selectPill(btn); });
    });

    // ── Modal open/close ──────────────────────────────────────────────────────
    function openModal() {
      modal.hidden = false;
      preloadColorImages();
      updatePillStates();
      document.body.style.setProperty('overflow', 'hidden', 'important');
      document.documentElement.style.setProperty('overflow', 'hidden', 'important');
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
      selectedOptions = new Array(optionCount).fill(null);
      varInput.value = '';
      modalCta.disabled = true;
      modalCta.classList.remove('is-loading');
      modal.querySelectorAll('.fgp-modal__pill').forEach(b => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      unavailable.hidden = true;
    }

    modalClose?.addEventListener('click', closeModal);
    modalOver?.addEventListener('click', closeModal);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    // ── Skip ──────────────────────────────────────────────────────────────────
    modalSkip?.addEventListener('click', async () => {
      closeModal();
      if (!pendingVariantId) return;
      try {
        await addItems([{
          id: parseInt(pendingVariantId, 10),
          quantity: pendingQty,
          properties: pendingProps
        }]);
        triggerCartUpdate();
      } catch(e) { console.error('[FGP] skip error', e); }
    });

    // ── CTA ───────────────────────────────────────────────────────────────────
    modalCta.addEventListener('click', async () => {
      const giftId = varInput.value;
      if (!giftId || !pendingVariantId) return;

      // Bug 4: spinner
      modalCta.classList.add('is-loading');
      modalCta.disabled = true;

      try {
        // Bug 1: rimuovi regalo duplicato prima di aggiungere
        await removeExistingGifts();

        await addItems([
          { id: parseInt(pendingVariantId, 10), quantity: pendingQty, properties: pendingProps },
          { id: parseInt(giftId, 10), quantity: 1, properties: { [GIFT_PROP]: GIFT_VAL } }
        ]);
        closeModal();
        triggerCartUpdate();
      } catch(e) {
        console.error('[FGP] add error', e);
        modalCta.classList.remove('is-loading');
        modalCta.disabled = false;
      }
    });

    // ── Bug 2+6: Intercept ALL ATC buttons including sticky ───────────────────
    function bindAtcButtons() {
      // Use querySelectorAll to catch both main ATC and sticky ATC
      const forms = document.querySelectorAll('form.js-product-form');
      forms.forEach(form => {
        const btns = form.querySelectorAll('button[name="add"]');
        btns.forEach(btn => {
          btn.addEventListener('click', e => {
            const variantId = form.querySelector('input[name="id"]')?.value;
            if (!variantId) return;

            e.preventDefault();
            e.stopImmediatePropagation();

            const qty = parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10);
            const props = {};
            form.querySelectorAll('input[name^="properties"]').forEach(inp => {
              const m = inp.name.match(/properties\[(.+)\]/);
              if (m) props[m[1]] = inp.value;
            });

            pendingVariantId = variantId;
            pendingQty = qty;
            pendingProps = props;

            openModal();
          }, { capture: true });
        });
      });
    }

    bindAtcButtons();
  }

  // ── Bug 1: Remove existing gift items from cart ─────────────────────────────
  async function removeExistingGifts() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const gifts = cart.items.filter(
      item => item.properties && item.properties[GIFT_PROP] === GIFT_VAL
    );
    if (gifts.length === 0) return;

    // Remove all existing gift items
    const updates = {};
    gifts.forEach(item => { updates[item.key] = 0; });
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }

  // ── Cart helpers ────────────────────────────────────────────────────────────
  async function addItems(items) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!r.ok) {
      const e = await r.json();
      throw new Error(e.description || 'Cart add failed');
    }
    return r.json();
  }

  function triggerCartUpdate() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
  }

  // ── Boot ────────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
